<template>

  <div class="flex w-full h-screen bg-gray-50">
    <div class="flex-1 w-full overflow-y-auto">
      <Topbar />
        <div class="p-8" style="margin-top:64px;">
          <div class="flex justify-center items-center mb-6 relative">
              <div class="absolute left-0">
                  <RouterLink to="/employee" class="flex-none text-red-500 rounded-xl hover:text-red-700 cursor-pointer"> Назад </RouterLink>
              </div>
              <h2 class="text-2xl font-bold flex items-center gap-2">
                  <i class="pi pi-users" style="font-size: 2rem"></i>  Учет рабочего времени (факт)
              </h2>
          </div>
      
          <Toast />
          <div class="card">
              <DataTable :value="rows" responsiveLayout="scroll" :paginator="true" :loading="loading" :rows="8" :rowsPerPageOptions="[5, 8, 10, 12]"
                  ref="workingHoursTable" size="small" resizableColumns  columnResizeMode="fit"  showGridlines scrollable
                  :filters="filters" filterDisplay="menu" :globalFilterFields="['name', 'position']"
              >   
              <template #header>
                      <div class="flex justify-between">
                          <div class="flex flex-wrap gap-2 items-center justify-between">
                              <IconField>
                                  <InputIcon> <i class="pi pi-search" /> </InputIcon>
                                  <InputText v-model="filters['global'].value" placeholder="Поиск..." class="h-11" />
                              </IconField>
                              <FloatLabel variant="on">
                                  <label for="on_label" class="z-10"> Месяц </label>
                                  <DatePicker v-model="selectedMonth" :invalid="!selectedMonth" view="month" size="small" dateFormat="yy-mm" inputId="on_label" showIcon iconDisplay="input" />
                              </FloatLabel>
                          </div>
                          <div class="flex">
                              <Button icon="pi pi-upload" severity="info" @click="exportCSV($event)" />
                          </div>
                      </div>
                  </template>
                  <Column field="name" header="ФИО" frozen class="bg-white z-10"/>
                  <Column field="position" header="Должность" />
                  <Column field="payment" header="Способ оплаты" />
              
                  <Column v-for="date in dates" :key="date" :header="date" class="!text-center">
                      <template #body="slotProps">
                          <div v-if="!isFuture(date)" class="text-xs" style="min-width: 75px;">
                              <Button icon="pi pi-times" v-if="slotProps.data[date].status == 0" severity="secondary" disabled/>
                              <div v-else-if="slotProps.data[date].status == 2" :class="classByStatus(slotProps.data[date].status)">
                                  <div>{{ slotProps.data[date]?.time_in || '-' }}</div>
                                  <div>{{ slotProps.data[date]?.time_out || '-' }}</div>
                                  <strong>{{ slotProps.data[date]?.hours || 0 }} ч</strong>
                              </div>
                              <Button icon="pi pi-question" v-else-if="slotProps.data[date].status == 3" severity="warn" disabled/>
                              <div class="" v-else-if="slotProps.data[date].status == 1" :class="classByStatus(slotProps.data[date].status)">
                                  <div>{{ slotProps.data[date]?.time_in || '-' }}</div>
                                  <div>{{ slotProps.data[date]?.time_out || '-' }}</div>
                                  <strong>{{ slotProps.data[date]?.hours || 0 }} ч</strong>
                              </div>
                          </div>
                          <div v-else class="text-gray-400 italic">—</div>
                      </template>
                  
                      <template #footer>
                          {{rows.reduce((sum, r) => sum + (r[date]?.hours || 0), 0).toFixed(1)}}
                      </template>
                  </Column>
              </DataTable>
          </div>
        </div>
        </div>
    </div>
</template>

<script setup>
import axios from '../lib/axios'
import { ref, onMounted, computed, watch } from 'vue'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import { useToast } from 'primevue/usetoast'
import { useRouter } from 'vue-router'
import Toast from 'primevue/toast'
import dayjs from 'dayjs'

const toast = useToast()
const loading = ref(false)
const router = useRouter()
const selectedMonth = ref(dayjs().format('YYYY-MM'))

const workingHours = ref([])
const workingHoursTable = ref()
const columns = ref([])
const editingRows = ref([])
const totalPerDay = ref()
const totalDays = ref()
const totalSum = ref()
const rows = ref([])
const dates = ref([])
const today = new Date();

function isFuture(dateStr) {
  const d = new Date(dateStr);
  return d > today;
}

// filters
const filters = ref({
    'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
})

const initFilters = () => {
    filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    }
}
initFilters()

const clearFilter = () => {
    initFilters()
}

const month = computed(() => {
    return dayjs(selectedMonth.value).format('YYYY-MM')
})

watch(selectedMonth, (newValue, oldValue) => {
    fetchWorkingHoursTable()
    return dayjs(newValue).format('YYYY-MM')
})

// get data
const fetchWorkingHoursTable = (event) => {
    loading.value = true

    const {data} = axios.get('/api/get-working-hours?date=' + month.value + '-01')
        .then(response => {
            rows.value = response.data.rows
            dates.value = response.data.dates
            // workingHours.value = response.data;
            loading.value = false
        })
        .catch(error => {
            toast.add({severity:'error', summary: 'Ошибка!', detail: error, life: 3000})
        });
};

const classByStatus = (status) => {
    if (status === 1) {
        return 'border border-green-300 bg-green-200 p-1 rounded'
    } else if (status === 2) {
        return 'border border-blue-300 bg-blue-200 p-1 rounded'
    }
}
const onRowEditSave = async (event) => {
    const { newData, index } = event

    // try {
    //     await axios.put(`/api/work-schedule-fact/${event.data.id}`, event.newData)
    //     workScheduleFact.value[index] = newData
    //     fetchWorkScheduleFact()
    //     toast.add({severity:'success', summary: 'Успешно!', detail: 'Изменения сохранены', life: 3000})
    // }   catch   {
    //     toast.add({severity:'error', summary: 'Ошибка!', detail: 'Не удалось сохранить изменения', life: 3000})
    // }
}

const exportCSV = () => {
    workingHoursTable.value.exportCSV({ selectionOnly: false});
}

onMounted(() => {
    fetchWorkingHoursTable()
})
</script>